//@ts-nocheck TS6133
/* eslint-disable @typescript-eslint/no-duplicate-imports */
import type * as Types from 'owa-graph-schema';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { BookingBusinessInformationFragmentFragmentDoc } from '../../fragments/__generated__/BookingBusinessInformationFragment.interface';
import { BookingBusinessPageFragmentFragmentDoc } from '../../fragments/__generated__/BookingBusinessPageFragment.interface';
export type GetBookingBusinessQueryVariables = Types.Exact<{
    businessId?: Types.InputMaybe<Types.Scalars['String']>;
}>;
export type GetBookingBusinessQuery = {
    __typename?: 'Query';
    getBookingBusiness?: {
        __typename?: 'GetBookingBusinessResponse';
        businessInfo?: {
            __typename?: 'BookingBusinessEntry';
            businessTimeZone?: string | null;
            businessLanguage?: string | null;
            displayName?: string | null;
            businessType?: string | null;
            phone?: string | null;
            email?: string | null;
            websiteUrl?: string | null;
            defaultCurrencyIso?: string | null;
            currencySymbol?: string | null;
            privacyPolicyUrl?: string | null;
            termsAndConditionsUrl?: string | null;
            customOnlineMeetingUrl?: string | null;
            businessName?: string | null;
            mailboxId?: string | null;
            isPublished?: boolean | null;
            businessHours?: Array<{
                __typename?: 'BookingWorkHours';
                day?: string | null;
                timeSlots?: Array<{
                    __typename?: 'BookingsWorkTimeSlot';
                    start?: number | null;
                    end?: number | null;
                } | null> | null;
            } | null> | null;
            address?: {
                __typename?: 'BookingPostalAddress';
                name?: string | null;
                street?: string | null;
                city?: string | null;
                state?: string | null;
                countryOrRegion?: string | null;
                postalCode?: string | null;
                postOfficeBox?: string | null;
                locationSource?: Types.BookingLocationSourceType | null;
                type?: string | null;
            } | null;
            schedulingPolicy?: {
                __typename?: 'BookingSchedulingPolicy';
                allowStaffSelection?: boolean | null;
                maximumAdvance?: string | null;
                minimumLeadTime?: string | null;
                sendConfirmationsToOwner?: boolean | null;
                sendMeetingInviteToCustomer?: boolean | null;
                timeSlotInterval?: string | null;
                hasCustomServiceWindows?: boolean | null;
                bookingServiceWindows?: Array<{
                    __typename?: 'BookingServiceWindow';
                    startDate?: string | null;
                    endDate?: string | null;
                    bookableHours?: Array<{
                        __typename?: 'BookingWorkHours';
                        day?: string | null;
                        timeSlots?: Array<{
                            __typename?: 'BookingsWorkTimeSlot';
                            start?: number | null;
                            end?: number | null;
                        } | null> | null;
                    } | null> | null;
                } | null> | null;
            } | null;
            settings?: {
                __typename?: 'BookingSettings';
                otpVerificationSetting?: Types.BookingOtpSettings | null;
                publishingUrl?: string | null;
                c2RevampedEnabled?: boolean | null;
                authType?: Types.BookingSelfServicePageAuthType | null;
                friendlyUrl?: string | null;
                isLogoHidden?: boolean | null;
                isConsentNeeded?: boolean | null;
                consentText?: string | null;
                customColorScheme?: string | null;
                isSearchEngineIndexabilityDisabled?: boolean | null;
                showTimeSlotsInBusinessTimeZone?: boolean | null;
                emailVerificationMethod?: Types.BookingEmailVerificationMethod | null;
                sendMeetingInviteToCustomer?: boolean | null;
                onDemandServicesSetting?: Types.BookingOnDemandServicesSettings | null;
                themeData?: {
                    __typename?: 'BookingThemeData';
                    paletteId?: number | null;
                    patternId?: number | null;
                    pictureId?: number | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export const GetBookingBusinessDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetBookingBusiness' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'businessId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'getBookingBusiness' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'request' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'businessId' },
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'businessInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'BookingBusinessInformationFragment',
                                                },
                                            },
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'BookingBusinessPageFragment',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'businessTimeZone' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'businessLanguage' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...BookingBusinessInformationFragmentFragmentDoc.definitions,
        ...BookingBusinessPageFragmentFragmentDoc.definitions,
    ],
} as unknown as DocumentNode<GetBookingBusinessQuery, GetBookingBusinessQueryVariables>;
